import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { Observer } from "gsap/Observer";
import horizontalLoop from "@js/utils/gsapHorizontalLoop";

gsap.registerPlugin(ScrollTrigger);

function cloneHTMLElement(item, n = 2, parent = null) {
  if (parent == null) parent = item.parentNode;

  Array.from({ length: n }).forEach(() => parent.append(item.cloneNode(true)));
}

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll("[data-gsap-h-gallery]");

  blocks.forEach((block) => {
    const trigger = block.querySelector("[data-gsap-h-gallery-trigger]");
    const trail = trigger.querySelector(
      ".scrolling-gallery__trail .wp-block-gallery",
    );
    const slides = trail.querySelectorAll(".wp-block-image").length;
    const cloneItem = trail.querySelector(".wp-block-image");
    // create 2 more cloneItem html elements to create a loop effect
    // cloneHTMLElement(cloneItem, slides <= 6 ? 4 : slides, trail);

    const scrollingItem = gsap.utils.toArray(trail.children);

    const tl = horizontalLoop(scrollingItem, {
      repeat: -1,
    });

    if (ScrollTrigger.isTouch === 1) {
      tl.timeScale(0.5);
    }

    let speedTween;

    const scrollTrigger = ScrollTrigger.create({
      trigger,
      start: "top bottom",
      end: "bottom top",
      onUpdate:
        ScrollTrigger.isTouch === 1
          ? undefined
          : (self) => {
              speedTween && speedTween.kill();
              speedTween = gsap
                .timeline()
                .to(tl, {
                  timeScale: 2.5 * self.direction,
                  duration: 0.25,
                })
                .to(
                  tl,
                  {
                    timeScale: 0.5 * self.direction,
                    duration: 1.5,
                  },
                  "+=0.5",
                );
            },
    });
    // Observer.create({
    //   onChangeY(self) {
    //     let factor = 2.5;
    //     if (self.deltaY < 0) {
    //       factor *= -1;
    //     }
    //     gsap
    //       .timeline({
    //         defaults: {
    //           ease: "none",
    //         },
    //       })
    //       .to(tl, { timeScale: factor * 2.5, duration: 0.2 })
    //       .to(tl, { timeScale: factor / 2.5, duration: 1 }, "+=0.3");
    //   },
    // });
  });
});
